// extracted by mini-css-extract-plugin
export default {"titulo":"ColumnaDivisionesPais_titulo__-zrQY","listado":"ColumnaDivisionesPais_listado__3rOY5","division":"ColumnaDivisionesPais_division__6Jk-q"};